import { StrictMode } from "react";
import "./i18n/index.ts";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import clarity from "@microsoft/clarity";

const clarityProjectId = import.meta.env.VITE_CLARITY_PROJECT_ID as string | undefined;
if (typeof window !== "undefined" && clarityProjectId && import.meta.env.PROD) {
  clarity.init(clarityProjectId);
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
